<template>
    <div :class="[ !labelRank ? 'w-100' : 'w-auto', {'stacked-label' : labelRank}, rankingCssClass]">
        <div v-if="labelRank" class="label-rank">
            <i class="ecom-trophy"/>
            {{ labelRank }}
        </div>
        <div ref="label" class="label-likes" :class="{'label-container-mobile' : !isDesktop}"> 
            <i class="ecom-favourite-full" /> 
            {{ likes }} 
        </div>
    </div>
</template>
<script>
export default {
    name: 'BlockLikes',
    props:{
        likes:{
            type: Number,
            default: 0
        },
        rank:{
            type: Number,
            default: 0
        },
        labelRank: {
            type: String,
            default: ''
        },
        rankingCssClass: {
            type: String,
            default: ''
        },
        isDesktop: {
            type: Boolean,
            default: true
        }
    },
    mounted() {},
    data() {
        return {}
    }
}
</script>